import request from '../request';
import qs from 'qs'

export type ProjectCostItem = {
  generalContractID: number;
  budgetContractAmount: number;
  subcontractAmount: number;
  totalContractAmount: number;
  subitemDesignMajor: string;
  salesContractCode: string;
  budgetMoney: number
};

export type GetProjectCostsResult = ProjectCostItem[];

/**
 * 获取项目成本列表
 * @param {string} code 总包项目编号 
 */
export const getProjectCosts = async (code: string) => {
  return await request.get<any, GetProjectCostsResult>('/workbenchApi/projects/general-contracts', {
    params: {
      code,
    },
  });
};

export type UpdateProjectCostsArgs = {
  generalContracts: Pick<ProjectCostItem, 'budgetContractAmount' | 'totalContractAmount' | 'generalContractID'>[],
};

/**
 * 修改项目成本
 */
export const updateProjectCosts = async (args: UpdateProjectCostsArgs) => {
  return await request.post<any, {}>('/workbenchApi/projects/general-contracts', args);
};
export const getHumanCostApi = (id: string | number) => {
  return request.get<any, API.PROJECT.HumanCostResult>(`/workbenchApi/op/projects/${id}/budgets`)
}
/**********************新api 根据部门权限******************/
export const getHumanCostNewApi = (id: string | number, departs: string[]) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat'})
  return request.get<any, API.PROJECT.HumanCostResult>(`/workbenchApi/budgets/projects/${id}/participants?${params}`)
}
export const getBudgetsDepartmentsApi = (id: string | number, isBudget = false) => {
  return request.get<any, Department[]>(`/workbenchApi/budgets/projects/${id}/departments?isBudget=${isBudget}`)
}
export const getProjectCostNewApi = (id: string | number, departs: string[]) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
  return request.get<any, API.PROJECT.CostResult>(`/workbenchApi/budgets/projects/${id}/costs?${params}`)
}
export const saveProjectCostNewApi = (id: string | number, data: Partial<API.PROJECT.Cost>[]) => {
  return request.post(`/workbenchApi/budgets/projects/${id}/costs`, {
    projectCosts: data
  })
}
export const getCostVersionsNewApi = (id: string | number, departs: string[]) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
  return request.get<any, API.PROJECT.CostVersion[]>(`/workbenchApi/budgets/projects/${id}/versions?${params}`)
}
export const getCostVersionDetailNewApi = (versionID: number, departs: string[]) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
  return request.get<any, API.PROJECT.CostVersionDetail>(`/workbenchApi/budgets/projects/versions/${versionID}?${params}`)
}
export const saveProjectCostVersionNewApi = (id: string | number, data: { changeReason: string }) => {
  return request.post(`/workbenchApi/budgets/projects/${id}/versions`, data)
}
export const getActualCostDetailNewApi = (id: string | number, departs: string[]) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
  return request.get<any, API.PROJECT.ActualCost>(`/workbenchApi/budgets/projects/${id}/detail-costs?${params}`)
}
/**********************新api 根据部门权限******************/

export const getProjectCostApi = (id: string | number) => {
  return request.get<any, API.PROJECT.Cost[]>(`/workbenchApi/op/projects/${id}/costs`)
}
export const getProjectCostItemsApi = () => {
  return request.get<any, API.PROJECT.CostItem[]>(`/workbenchApi/op/projects/costs/items`)
}
export const getProjectCostItemTypesApi = () => {
  return request.get<any, API.PROJECT.CostItemType[]>(`/workbenchApi/op/projects/costs/types`)
}
export const saveProjectCostVersionApi = (id: string | number, data: { changeReason: string }) => {
  return request.post(`/workbenchApi/op/projects/${id}/versions`, data)
}
export const saveProjectCostApi = (id: string | number, data: Partial<API.PROJECT.Cost>[]) => {
  return request.post(`/workbenchApi/op/projects/${id}/costs`, {
    projectCosts: data
  })
}
export const getCostVersionsApi = (id: string | number) => {
  return request.get<any, API.PROJECT.CostVersion[]>(`/workbenchApi/op/projects/${id}/versions`)
}
export const getCostVersionDetailApi = (versionID: number) => {
  return request.get<any, API.PROJECT.CostVersionDetail>(`/workbenchApi/op/projects/versions/${versionID}`)
}
export const deleteCostVersionApi = (versionID: number) => {
  return request.delete(`/workbenchApi/op/projects/versions/${versionID}`)
}
export const getActualCostDetailApi = (id: string | number) => {
  return request.get<any, API.PROJECT.ActualCost>(`/workbenchApi/op/projects/${id}/detail-costs`)
}


export const getCostIframeUrlApi = (pageType = 1, projectID = "", departs: string[] = []) => {
  const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
  return request.get<any, { url: string }>(`/workbenchApi/auth/rpt-login?pageType=${pageType}&projectID=${projectID}&${params}`)
}